(()=>{
  const initCollection=section=>{
    if(!section||section.dataset.akCollectionTabsReady==='true')return;

    const tabs=[...section.querySelectorAll('[data-ak-collection-filter]')];
    const cards=[...section.querySelectorAll('[data-ak-product-category]')];
    const countLabel=section.querySelector('[data-ak-visible-count]');
    const filterLabel=section.querySelector('[data-ak-filter-label]');

    if(!tabs.length||!cards.length)return;
    section.dataset.akCollectionTabsReady='true';

    const countFor=category=>cards.filter(card=>card.dataset.akProductCategory===category).length;

    const setFilter=(category,{focus=false}={})=>{
      const safeCategory=(category==='bacon'&&countFor('bacon')>0)?'bacon':(countFor('beef')>0?'beef':'bacon');

      tabs.forEach(tab=>{
        const active=tab.dataset.akCollectionFilter===safeCategory;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',active?'true':'false');
        tab.tabIndex=active?0:-1;
        if(active&&focus)tab.focus({preventScroll:true});
      });

      let visible=0;
      cards.forEach(card=>{
        const show=card.dataset.akProductCategory===safeCategory;
        card.hidden=!show;
        card.setAttribute('aria-hidden',show?'false':'true');
        if(show)visible+=1;
      });

      const readable=safeCategory==='bacon'?'BACON JERKY':'BEEF JERKY';
      if(filterLabel)filterLabel.textContent=readable;
      if(countLabel)countLabel.textContent=`${visible} AVAILABLE ${readable}`;

      section.dataset.akActiveJerkySide=safeCategory;
    };

    tabs.forEach((tab,index)=>{
      const category=tab.dataset.akCollectionFilter;
      if(countFor(category)===0){
        tab.disabled=true;
        tab.setAttribute('aria-disabled','true');
      }

      tab.addEventListener('click',()=>setFilter(category));
      tab.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight'].includes(event.key))return;
        event.preventDefault();
        const direction=event.key==='ArrowRight'?1:-1;
        let next=index;
        for(let tries=0;tries<tabs.length;tries+=1){
          next=(next+direction+tabs.length)%tabs.length;
          if(!tabs[next].disabled){
            setFilter(tabs[next].dataset.akCollectionFilter,{focus:true});
            break;
          }
        }
      });
    });

    const requested=new URLSearchParams(window.location.search).get('side');
    setFilter(requested==='bacon'?'bacon':'beef');
  };

  const initAll=(scope=document)=>scope.querySelectorAll?.('[data-ak-jerky-collection]').forEach(initCollection);

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>initAll(document),{once:true});
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  window.addEventListener('pageshow',()=>initAll(document));
})();
